import React from "react"
import Cabecalho from "../Cabecalho"
import { FaixasDistanciaForm } from "./components/FaixasDistanciaForm"

export function AtribuirFaixasDistancia() {
    return (
        <>
            <Cabecalho pagina="Faixas de Distância" />
            <FaixasDistanciaForm />
        </>
    )
}
